import { ASSESSMENT_TAB, TABS } from "./riskColumns";
import { EditorRow, Filters, insertAddedRows, isRowChanged } from "./riskEditorState";

export interface RestoredDraft {
	rows: EditorRow[];
	tab: string;
	filters: Filters;
	changedKeys: Set<string>;
}

interface SavedDraft {
	rows?: EditorRow[];
	tab?: string;
	filters?: Filters | null;
}

export function serializeDraft(rows: EditorRow[], tab: string, filters: Filters): string {
	return JSON.stringify({ rows: rows.filter(isRowChanged), tab, filters });
}

function parseDraft(state: string | null): SavedDraft | null {
	if (!state) {
		return null;
	}
	try {
		const parsed = JSON.parse(state);
		return parsed && typeof parsed === 'object' ? parsed : null;
	} catch (error) {
		return null;
	}
}

export function savedDraftRows(state: string | null): EditorRow[] {
	const saved = parseDraft(state);
	return saved && Array.isArray(saved.rows) ? saved.rows : [];
}

export function restoreDraft(base: EditorRow[], state: string | null): RestoredDraft {
	const saved = parseDraft(state);
	if (!saved) {
		return { rows: base, tab: ASSESSMENT_TAB, filters: {}, changedKeys: new Set() };
	}
	const savedRows = Array.isArray(saved.rows) ? saved.rows : [];
	const byKey = new Map(savedRows.filter(row => !row.added).map(row => [row.key, row] as [string, EditorRow]));
	const rows = insertAddedRows(base.map(row => byKey.get(row.key) || row), savedRows.filter(row => row.added));
	return {
		rows,
		tab: saved.tab && TABS.includes(saved.tab) ? saved.tab : ASSESSMENT_TAB,
		filters: saved.filters && typeof saved.filters === 'object' ? saved.filters : {},
		changedKeys: new Set(savedRows.map(row => row.key))
	};
}